module.exports = __webpack_public_path__ + "74b7bb27b901f2a0150883a9e05510c2.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/163.png
// module id = 1758
// module chunks = 2